import { AppButton } from 'components/form';
import { Select } from '@trackman/web-shared-components';
import { t } from 'utilities/TranslationUtils';
import { useState } from 'react';

type SelectFilterProps = {
  filter: { options: any[]; type: string; selectProps?: any; label?: string };
  onApply: (value?: any) => void;
};

export const SelectFilter = ({ filter, onApply }: SelectFilterProps) => {
  const [value, setValue] = useState<string | number | undefined>();

  return (
    <div className='data-table-filter-content gap-10px'>
      <Select
        label={filter?.label || ''}
        value={value}
        selectOptions={filter?.options || []}
        onKeyDown={(e) => e.key === 'Enter' && onApply(value)}
        onChange={(e) => {
          setValue(e.target.value as string | number | undefined);
        }}
      />

      <AppButton
        data-test='ApplySelectFilterSubmit'
        type='button'
        className='apply-button '
        variant='primary'
        onClick={() => onApply(value)}
      >
        {t('common.apply')}
      </AppButton>
    </div>
  );
};

export default SelectFilter;
